define( [
	"./fnToString"
], function( fnToString ) {
	"use strict";

	return fnToString.call( Object );
} );



//////////////////
// WEBPACK FOOTER
// ../node_modules/jquery/src/var/ObjectFunctionString.js
// module id = 1195
// module chunks = 21 22 23 24 25 29 30